import { Box, Card, Tab } from "@mui/material";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import VisitorsGrid from "./VisitorsGrid";
import MaterialTypeGrid from "./MaterialTypeGrid";
import TitleVolumeGrid from "./TitleVolumeGrid";
import ProgramCirGrid from "./ProgramCirGrid";
import DueMaterialGrid from "./DueMaterialGrid";
import RecentlyAddedBooksGrid from "./RecentlyAddedBooksGrid";
import CirculationGrid from "./CirculationGrid";
import YearlyCirculationGrid from "./YearlyCirculationGrid";
import MonthlyCirculationGrid from "./MonthlyCirculationGrid";
import GeneralCard from "./GeneralCard";
import useDashboardStore from "../store/DashboardStore";

const List = () => {
  const { value, setValue } = useDashboardStore();

  const handleChange = (_: React.SyntheticEvent, newValue: string) => {
    setValue(newValue);
  };

  return (
    <>
      <Box sx={{ width: "100%", typography: "body1" }}>
        <TabContext value={value}>
          <Box>
            <TabList
              onChange={handleChange}
              aria-label="Dashboard statistics api"
              variant="scrollable"
              scrollButtons="auto"
              allowScrollButtonsMobile
               sx={{
                  marginBlock: "0em",
                  "& .MuiTabScrollButton-root.Mui-disabled": {
                    width: 0,
                    display: "none",
                  },
            }}
            >
              <Tab
                sx={{
                  backgroundColor: "white",
                  marginInline: "4px",
                }}
                label="Library Statistics"
                value="1"
              />
              <Tab
                sx={{
                  backgroundColor: "white",
                  marginInline: "4px",
                }}
                label="Visitors"
                value="2"
              />
              <Tab
                sx={{
                  backgroundColor: "white",
                  marginInline: "4px",
                }}
                label="Material Type"
                value="3"
              />
              <Tab
                sx={{
                  backgroundColor: "white",
                  marginInline: "4px",
                }}
                label="Material Accessions"
                value="4"
              />
              <Tab
                sx={{
                  backgroundColor: "white",
                  marginInline: "4px",
                }}
                label="Circulation"
                value="5"
              />
              <Tab
                sx={{
                  backgroundColor: "white",
                  marginInline: "4px",
                }}
                label="Program Wise Circulation"
                value="6"
              />
              <Tab
                sx={{
                  backgroundColor: "white",
                  marginInline: "4px",
                }}
                label="Yearly Circulation"
                value="7"
              />
              <Tab
                sx={{
                  backgroundColor: "white",
                  marginInline: "4px",
                }}
                label="Monthly Circulation"
                value="8"
              />
              <Tab
                sx={{
                  backgroundColor: "white",
                  marginInline: "4px",
                }}
                label="Due Material"
                value="9"
              />
              <Tab
                sx={{
                  backgroundColor: "white",
                  marginInline: "4px",
                }}
                label="Recently Added Books"
                value="10"
              />
            </TabList>
          </Box>
          <TabPanel value="1" sx={{ paddingInline: "0px" }}>
            <GeneralCard />
          </TabPanel>
          <TabPanel value="2" sx={{ paddingInline: "0px" }}>
            <VisitorsGrid />
          </TabPanel>
          <TabPanel value="3" sx={{ paddingInline: "0px" }}>
            <Card sx={{ padding: "1.5em" }}>
              <MaterialTypeGrid />
            </Card>
          </TabPanel>
          <TabPanel value="4" sx={{ paddingInline: "0px" }}>
            <TitleVolumeGrid />
          </TabPanel>
          <TabPanel value="5" sx={{ paddingInline: "0px" }}>
            <CirculationGrid />
          </TabPanel>
          <TabPanel value="6" sx={{ paddingInline: "0px" }}>
            <ProgramCirGrid />
          </TabPanel>
          <TabPanel value="7" sx={{ paddingInline: "0px" }}>
            <YearlyCirculationGrid />
          </TabPanel>
          <TabPanel value="8" sx={{ paddingInline: "0px" }}>
            <MonthlyCirculationGrid />
          </TabPanel>
          <TabPanel value="9" sx={{ paddingInline: "0px" }}>
            <DueMaterialGrid />
          </TabPanel>
          <TabPanel value="10" sx={{ paddingInline: "0px" }}>
            <RecentlyAddedBooksGrid />
          </TabPanel>
        </TabContext>
      </Box>
    </>
  );
};
export default List;
